import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CTAButton from '../ctaButton/CTAButton';
import List from '../list/List';

const Card = ({ subtitle, title, cta, list, amount, bio, extend }) => {
  const cardClasses = classNames('card', {
    'card--main': extend
  });
  const cardsClasses = classNames('cards', {
    'cards--extended-container': extend
  });

  return (
    <div className={cardsClasses}>
      <div className={cardClasses}>
        <div className="card__wrapper">
          <div className="card__info">
            {title && <h2 className="card__title">{title}</h2>}
            {subtitle && <h3 className="card__title">{subtitle}</h3>}
            {bio && <p className="card__txt">{bio}</p>}
            {amount && (
              <div className="card__price">
                {amount.map((item, i) => {
                  return (
                    <p key={item.number + i} className="card__txt">
                      £<span className="card__txt card__txt--large">{item.number}</span>
                      <span className="card__txt card__txt--fade">{item.text ? item.text : '/mo'}</span>
                      {item.note && <span className="card__txt card__txt--block">{item.note}</span>}
                    </p>
                  );
                })}
              </div>
            )}
          </div>
          {list ? (
            <List customPadding="no-padding" sectionClass="card__list">
              {list.map((item) => (
                <List.Item key={item.text} text={item.text} tooltip={item.bio} icon="Tick" />
              ))}
            </List>
          ) : null}
        </div>
        {cta && (
          <div className="card__cta-group">
            {cta.map((data, i) => {
              return data.button ? (
                <CTAButton key={data.link + i} {...data} />
              ) : (
                <a key={data.link + i} href={data.link}>
                  {data.text}
                </a>
              );
            })}
          </div>
        )}
      </div>
      {extend ? (
        <div className="cards cards--extended">
          {extend.map((item, i) => {
            return (
              <div key={item.title + i} className="card card--extend">
                <h3 className="card__title">{item.title}</h3>
                {item.list ? (
                  <List customPadding="no-padding" sectionClass="card__list">
                    {item.list.map((item) => (
                      <List.Item key={item.text} text={item.text} tooltip={item.bio} icon="Tick" />
                    ))}
                  </List>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

Card.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  list: PropTypes.array,
  amount: PropTypes.array,
  bio: PropTypes.string,
  extend: PropTypes.array,
  cta: PropTypes.array
};

export default Card;
